import { WarningCircleRegisterFranchise } from 'common/SVG/svg.common';

export const messageRequireIcon = (text: string) => {
   return (
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px', marginBottom: '8px' }}>
         <div style={{ display: 'flex', alignItems: 'center' }}>
            <WarningCircleRegisterFranchise />
         </div>
         <span style={{ marginLeft: 5, textAlign: 'left', fontWeight: 500 }}>{text}</span>
      </div>
   );
};
